import { render, staticRenderFns } from "./guide-setup-after-install.vue?vue&type=template&id=4afd5dd3"
import script from "./guide-setup-after-install.vue?vue&type=script&lang=js"
export * from "./guide-setup-after-install.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports